import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Callout } from '@fluentui/react';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { useReportsHistory } from '@bingads-webui-campaign/reports-v4-history';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { MultipleAccountSelector } from './multiple-account-selector';
import { UserScopeInput } from './user-scope-input';
import { getUserIdFromScopeSelector, convertUserIdToScopeSelector, shouldShowSelector, shouldShowUserScopeInput, getDefaultMultiAccountSelectorInfo } from '../../helpers/account-selector-helper';
import { getAccountSelectorStyle } from './styles';

export function AccountSelectorCallout(props) {
  const {
    getSelectedScope, reportSchema, target, onApply, onDismiss, searchHistorySelectorOptions: searchHistorySelectorOptionsFromProps,
  } = props;
  const classes = useDefaultStyles(getAccountSelectorStyle);
  const { scope } = useContext(ScopeContext);
  const i18n = useContext(I18nContext);
  const history = useReportsHistory();

  function onAccountSelectedChange(selected, additionalInfo) {
    let newSelected = { ...selected };
    if (shouldShowUserScopeInput(reportSchema.ScopeFilterLevel)) {
      delete newSelected.allSelected;
    } else {
      // Not scope input condition
      // set to default value(which should be all selected) if not select anything
      // eslint-disable-next-line no-lonely-if
      if (newSelected.CustomerScopes.length === 0 &&
        newSelected.AccountIds.length === 0 &&
        newSelected.CampaignReportScopes.length === 0) {
        newSelected = getDefaultMultiAccountSelectorInfo(reportSchema, history);
      }
    }
    onApply(newSelected, additionalInfo);
  }

  function onUserScopeInputChange(newUserScope) {
    const newAccountSelectedInfo = convertUserIdToScopeSelector(newUserScope);
    onAccountSelectedChange(newAccountSelectedInfo);
  }

  const isMultipleAccountSelectorShown = shouldShowSelector(reportSchema.ScopeFilterLevel, scope);
  const isUserScopeInputShown = shouldShowUserScopeInput(reportSchema.ScopeFilterLevel);

  return (
    <Callout
      className={classes['scheduler-modal']}
      target={target}
      onDismiss={onDismiss}
      isBeakVisible={false}
    >
      {isMultipleAccountSelectorShown &&
        <MultipleAccountSelector
          onSelectedChange={onAccountSelectedChange}
          getDefaultSelected={getSelectedScope}
          onDismiss={onDismiss}
          reportSchema={reportSchema}
          searchHistorySelectorOptions={searchHistorySelectorOptionsFromProps}
        />
      }
      {isUserScopeInputShown &&
        <UserScopeInput
          userId={getUserIdFromScopeSelector(getSelectedScope())}
          onApplyClick={onUserScopeInputChange}
          onCancel={onDismiss}
          applyText={i18n.getString(_TL_('Save'))}
        />
      }
    </Callout>
  );
}

AccountSelectorCallout.propTypes = {
  target: PropTypes.string.isRequired,
  getSelectedScope: PropTypes.func.isRequired,
  reportSchema: PropTypes.shape({}).isRequired,
  onApply: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  searchHistorySelectorOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
